import HeadingBlock from "@/app/(site)/_components/GCSanityBlocks/HeadingBlock"
import EmptyCartShowcaseModuleContent from "@/app/(site)/_components/GCSanityModules/EmptyCartShowcaseModule/EmptyCartShowcaseModuleContent"
import { type CTAGroupType, type HeadingBlockType } from "@/types/gc-modules-types"
import { clsx } from "@/src/utils/clsx"

type EmptyCartShowcaseModuleData = {
    ctas: CTAGroupType[]
    headingBlock?: HeadingBlockType[]
}

type EmptyCartShowcaseModuleProps = {
    data?: EmptyCartShowcaseModuleData
    isAboveTheFold?: boolean
}

export default function EmptyCartShowcaseModule({
    data,
    isAboveTheFold = false
}: EmptyCartShowcaseModuleProps) {
    if (!data) return null

    const { ctas, headingBlock } = data

    if (!ctas) return null

    const HeadingBlockStyling =
        "[&_h2]:!normal-case [&_h2]:first-letter:!lowercase  max-w-[250px] sm:max-w-full [&>div]:col-span-full"
    const CTAContentStyling = "gap-12 sm:gap-24 md:gap-32 uppercase"

    return (
        <section className={clsx("flex flex-col", CTAContentStyling)}>
            {headingBlock && headingBlock?.length > 0 && (
                <HeadingBlock data={headingBlock[0]} className={HeadingBlockStyling} />
            )}
            <EmptyCartShowcaseModuleContent ctas={ctas} isAboveTheFold={isAboveTheFold} />
        </section>
    )
}
